<!-- eslint-disable no-mixed-spaces-and-tabs -->
<template>
	<section id="arvore-objeto">
        <container title="Árvores de objetos" textButton="Voltar" pathName="/objetos">
			<!-- <button class="btn" id="filtrar" type="button" @click="selectHandlerAdd()"
			style='
			position: fixed; right: 35px; bottom: 35px; border-radius: 50px; font-size: 2rem; width: 40px; height: 40px; border: none; background-color: #3367d6; color: white;'>+</button> -->
            <div id="main-container" >
				<section id="params-container" >
					<div class="field" id="inputContent" >
					<label for="AddPai"><i class="fa fa-plus" aria-hidden="true"></i> Adicionar um objeto pai:</label>
					<input type="text" id="AddPai" placeholder="Informe o numCod do objeto" name="formPai" v-model="formPai.codigo" @keyup.enter="putAddFilho(thicodigoFilho)"/>
					</div>
					<div class="acoes">
						<button class="btn" id="limpar" type="button" @click="limparPai(), submitPai()">Limpar</button>
						<button class="btn" id="filtrar" type="button" @click="submitPai()">Adicionar</button>
					</div>
				</section>
				<section id="params-container">
                    <div class="field" id="inputContentPai">
					<label for="filterPai"><i class="fas fa-filter"></i> Filtro:</label>
					<input type="text" id="filterPai" placeholder="Pesquise pelo título ou numCod do objeto pai ou filho"  v-model="pai" @keyup.enter="getObjetos()"/>
				    </div>

                    <div class="acoes">
                        <button class="btn" id="limpar" type="button" @click="limpar(), getObjetos()">Limpar</button>
                        <button class="btn" id="filtrar" type="button" @click="getObjetos(), limpar()">Pesquisar</button>
                    </div>
                </section>

                <div class="table-wrapper" >
                    <div class="table"  v-cloak>
                        <table>
                            <thead>
                                <tr>
                                    <th id="th-codigo">Título</th>
                                    <th id="th-nome" class="ordena" style="text-align: left;">Tipo de objeto<!--<i class="fas fa-arrow-up"></i>--></th>
                                    <th id="th-tipo">NumCod</th>
                                    <th id="th-acoes">Ações</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr class="fields" v-for="item in objetos" v-bind:key="item.arvoreObjetoId">
                                    <td class="objeto-codigo-amigavel" >
                                        {{item.titulo}}
                                    </td>
                                    <td class="objeto-nome" ><span>{{item.tipoNome}}</span></td>
                                    <td class="objeto-tipo text-overflow" ><span>{{item.codigo}}</span></td>
                                    <td class="acoes" >
                                        <div class="btn-container">
                                            <a class="acao actionPai" v-on:click="isModalVisible = !isModalVisible"
                                            @click="selectHandler(item), getFilhosObjetos(item.codigo)"><i class="far fa-eye" style="margin-right: 5px;"></i> Ver filhos</a>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <Modal v-show="isModalVisible" @close="() => this.isModalVisible = !this.isModalVisible">
					<template v-slot:body>
						<div v-bind:key="currentItem.id" >
							<h3 class="paiModalTitle"> Árvore de objetos: {{currentItem.titulo}}</h3>
							<section id="params-container">
								<div class="field" id="inputContent" style="text-align: left;">
								<label for="Titlepai">Associar um objeto filho a essa árvore</label>
								<input type="text" id="Titlepai" placeholder="Informe o numCod do objeto filho" name="codigoFilho" v-model="codigoFilho" @keyup.enter="putAddFilho(thicodigoFilho)"/>
								</div>
								<div class="acoes">
									<button class="btn" id="limpar" type="button" @click="limparFilho(), putAddFilho(codigoFilho)">Limpar</button>
									<button class="btn" id="filtrar" type="button" @click="putAddFilho(codigoFilho)">Adicionar</button>
								</div>
							</section>
							<div class="table-wrapper">
								<div class="table table-responsive"  style="padding-bottom: 0px; margin-bottom: 0px;">
									<table style="z-index: 3;">
										<thead>
											<tr>
												<th id="th-codigo">Título</th>
												<th id="th-nome" class="ordena">Tipo de objeto<!--<i class="fas fa-arrow-up"></i>--></th>
												<th id="th-tipo">NumCod</th>
												<th id="th-acoes">Ações</th>
											</tr>
										</thead>
										<tbody>
											<tr class="fields ">
												<td class="objeto-codigo-amigavel">
													<strong style="font-weight:500">{{currentItem.titulo}}</strong>
												</td>
												<td class="objeto-nome" ><span>{{currentItem.tipoNome}}</span></td>
												<td class="objeto-tipo text-overflow"  ><span>{{currentItem.codigo}}</span></td>
												<td class="acoes" >
													<div class="btn-container">
														<span class="copy-id-obj">
															<copiar :button="true" :text="currentItem.id" :hideText="true"></copiar>
														</span>
														<router-link
															class="editar acao"
															:to="{ name: 'objetoEdit', params: { id: currentItem.id }}">
															<i class="fas fa-pen"></i>
														</router-link>
														<router-link
															class="visualizar acao"
															:to="{ name: 'objetoDetalhes', params: { id: currentItem.id }}">
															<i class="far fa-eye"></i>
														</router-link>
														<span
															@click="openLink(currentItem.urlObjeto)"
															title="Acessar objeto"
															class="abrir_objeto fas fa-external-link-alt">
														</span>
														<button-remove
															v-if="renderForPerfil($auth.user().perfil)"
															:onClick="() => removePai(currentItem.codigo)"
															class="delete">
													</button-remove>
													</div>
												</td>
											</tr>
											<div class='tableFilho' v-if="showList" >
												<tr class="fields filho" v-for="filho in filhos" v-bind:key="filho.id">
													<td class="objeto-codigo-amigavel" >
														{{filho.titulo}}
													</td>
													<td class="objeto-nome" ><span>{{filho.tipoNome}}</span></td>
													<td class="objeto-tipo text-overflow" ><span>{{filho.codigo}}</span></td>
													<td class="acoes" >
														<div class="btn-container">
															<span class="copy-id-obj">
																<copiar
																	:button="true"
																	:text="filho.id"
																	:hideText="true">
																</copiar>
															</span>
															<router-link
																class="editar acao"
																:to="{ name: 'objetoEdit', params: { id: filho.id }}">
																<i class="fas fa-pen"></i>
															</router-link>
															<router-link
																class="visualizar acao"
																:to="{ name: 'objetoDetalhes', params: { id: filho.id }}">
																<i class="far fa-eye"></i>
															</router-link>
															<span
																@click="openLink(filho.urlObjeto)"
																title="Acessar objeto"
																class="abrir_objeto fas fa-external-link-alt">
															</span>
															<button-remove
																v-if="renderForPerfil($auth.user().perfil)"
																:onClick="() => removeFilhoObjeto(filho.codigo)"
																class="delete">
															</button-remove>
														</div>
													</td>
												</tr>
											</div>
											<tr v-if="notFound" class="objectNotFound">
												<td colspan="4" style="background-color: white;">
													<div style="text-align: center;">
													Nenhum objeto filho encontrado :)
												</div>
												</td>
											</tr>
										</tbody>
									</table>
								</div>
               				</div>
						</div>
						<span class="close" @click="closeModal()"><i class="fa fa-times" aria-hidden="true"></i></span>
					</template>
					<template v-slot:footer style>
					</template>
				</Modal>

				<!-- <Modal v-show="isModalVisibleAdd" @close="() => this.isModalVisibleAdd = !this.isModalVisibleAdd">
					<template v-slot:body>
						<div >
							<h3 style="color:#1b3772; padding-top: 0px; font-weight:500; font-size:1.5rem; text-transform: uppercase; text-align: left;">Objeto: {{currentItem.titulo}}</h3>
							<section id="params-container">
								<div class="field" id="inputContent" style="text-align: left;">
								<label for="idtagqa">Adicionar um objeto pai</label>
								<input type="text" id="idtagqa" placeholder="" name="formPai" v-model="formPai.codigo" @keyup.enter="putAddFilho(thicodigoFilho)"/>
								</div>
								<div class="acoes">
									<button class="btn" id="limpar" type="button" @click="limparPai(), submitPai()">Limpar</button>
									<button class="btn" id="filtrar" type="button" @click="submitPai()">Adicionar</button>
								</div>
							</section>
						</div>
						<span class="close" @click="closeModal()"><i class="fa fa-times" aria-hidden="true"></i></span>
					</template>
					<template v-slot:footer style>
					</template>
				</Modal> -->

            </div>
        </container>
    </section>

</template>

<script>

import axios from 'axios'
import Container from '@/components/shared/Container'
import Copiar from '@/components/shared/Copiar'
import ButtonRemove from '@/components/shared/ButtonRemove'
import Modal from '@/components/shared/Modal'
// import ItemEdit from '@/components/shared/ItemEdit'
// import { objetos } from '@/services/arvoreObjeto'

export default {
	name: 'arvoreObjeto',
	components: {
		Container,
		Copiar,
		ButtonRemove,
		Modal
	},
	data () {
		return {
			renderComponent: true,
			loading: true,
			objetos: [],
			pai: [],
			filhos: [],
			codigoFilho: '',
			codigoPai: '',
			isModalVisible: false,
			isModalVisibleAdd: false,
			removeItem: {},
			showList: false,
			notFound: true,
			formPai: {
				codigo: ''
			},
			currentItem: {
				arvoreObjetoId: '',
				titulo: '',
				id: '',
				codigoPai: '',
				codigo: ''
			}
		}
	},
	computed: {

	},
	created () {
		this.getObjetos()
		this.getAllArvoreObjeto()
		this.getFilhosObjetos()
		this.closeModal()
	},
	methods: {
		forceRerender () {
			this.renderComponent = false
			this.$nextTick(() => {
				this.renderComponent = true
			})
		},
		async getAllArvoreObjeto () {
			this.currentItem.titulo = ''
			this.currentItem.codigoPai = ''
			this.objetos = []
			await axios.get('/arvoreObjeto')
				.then(res => {
					this.objetos = res.data
					return this.objetos
				})
				.catch(error => {
					console.log(error.response.data.error)
				})
				.finally(() => {
					const err = this.loading = false
					return err
				})
		},
		async submitPai () {
			await this.axios.post('/arvoreObjeto', this.formPai).then(res => { window.location.reload() })
				.catch(error => {
					console.log(error.res.data.error)
				})
				.finally(() => {
					const err = this.loading = false
					return err
				})
		},

		async getObjetos () {
			const dado = this.pai
			this.currentItem.titulo = ''
			this.currentItem.codigoPai = ''
			this.objetos = []
			await axios.get(`/arvoreObjeto/${dado}`)
				.then(res => {
					this.objetos = res.data
					this.isLoading = true
					return this.objetos
				})
				.catch(error => {
					console.log(error.response.data.error)
				})
				.finally(() => {
					const err = this.loading = false
					return err
				})
		},

		async getFilhosObjetos (cod) {
			this.filhos = []
			await axios.get(`/arvoreObjeto/filhos/${cod}`)
				.then(res => {
					this.filhos = res.data
					this.isLoading = false
					return this.filhos
				})
				.catch(error => {
					console.log(error.response.data.error)
				})
				.finally(() => {
					const err = this.loading = false
					if (this.filhos <= 0) {
						this.notFound = true
					} else {
						this.showList = true
						this.notFound = false
					}
					return err
				})
		},

		async removeFilhoObjeto (cod) {
			await this.axios.delete(`/arvoreObjeto/filhos/excluir/${cod}`)
				.then((res) => {
					this.filhos = this.filhos.filter(data => data.cod !== cod)
					window.location.reload()
				})
				.catch(err => console.log(err))
				.finally(() => {
					const err = this.loading = false
					return err
				})
			await this.$nextTick()
		},
		async removePai (cod) {
			await this.axios.delete(`/arvoreObjeto/pai/excluir/${cod}`)
				.then((res) => {
					this.pai = this.pai.filter(data => data.cod !== cod)
					window.location.reload()
				})
				.catch(err => console.log(err))
				.finally(() => {
					const err = this.loading = false
					return err
				})
			await this.$nextTick()
		},
		async putAddFilho (codigoFilho) {
			await axios.put(`/arvoreObjeto/associar/${codigoFilho}`, {
				codigoPai: this.currentItem.codigo,
				codigo: this.codigoFilho
			})
				.then(res => {
					this.codigoFilho = codigoFilho
					this.codigoPai = this.currentItem.codigo
					this.isLoading = false
					window.location.reload()
				})
				//  .bind(this)
				.catch(error => {
					console.log(error.res.data.error)
				})
				.finally(() => {
					const err = this.loading = false
					return err
				})
			// await this.axios.delete(`/arvoreObjeto/filhos/excluir/${cod}`)
			// 	.then((res) => {
			// 		this.filhos = this.filhos.filter(data => data.cod !== cod)
			// 	})
			// 	.catch(err => console.log(err))
			// 	.finally(() => {
			// 		const err = this.loadng = false
			// 		return err
			// 	})
		},

		limpar () {
			this.pai = ''
		},
		limparFilho () {
			this.codigoFilho = ''
		},
		limparPai () {
			this.codigoPai = ''
		},
		selectHandlerAdd () {
			this.isModalVisibleAdd = true
		},
		selectHandler (data) {
			this.isModalVisible = true
			this.currentItem = data
		},
		openLink (url) {
			return url ? window.open(url) : false
		},
		renderForPerfil (perfil) {
			return [1, 2, 3, 4].find(auth => auth === perfil)
		},
		closeModal () {
			this.isModalVisible = false
			this.isModalVisibleAdd = false
			this.getAllArvoreObjeto()
		}

	}

}

</script>

<style lang="scss" scoped>

	#main-container{
		background-color: white;
		border-radius: $border-radius;
		margin-top:2rem;
		padding:2px;

		#params-container{
			background-color: $main-color;
			border-radius: 4px;
			margin-top: 15px;
			height: 100%;
			width: 100%;
			padding: 5px 10px 10px;
			display: grid;
			grid-template-columns: repeat(3, 1fr);
			grid-template-areas: "inputContent inputContent acoes";
			gap: 10px;

			@media only screen and (max-width: 640px) {
				grid-template-columns: repeat(1fr 2fr) !important;
				grid-template-areas: 	"inputContent inputContent inputContent"
										"acoes acoes acoes" !important;
			}

			#inputContentPai{
				grid-area: inputContent;

				label{
					color:white;
					font-size: 0.9rem;
					letter-spacing: 0.04rem;
				}

				input {
					width: 100%;
					height: 45px;
					padding: 16px;
					border: none;
					border-radius: $border-radius;
					background-color: #FFF;
				}
			}

			#inputContent{
				grid-area: inputContent;

				label{
					color:white;
					font-size: 0.9rem;
					letter-spacing: 0.04rem;
				}

				input {
					width: 100%;
					height: 45px;
					padding: 16px;
					border: none;
					border-radius: $border-radius;
					background-color: #FFF;
				}
			}

			.acoes {
				grid-area: acoes;
				justify-self: end;
				display: grid;
				grid-template-columns: 1fr 1fr;
				gap: 5px;
				margin-top: 1rem;

				.btn {
					background-color: $success-color;
					border: none;
					border-radius: 4px;
					outline: none;
					padding: 20px 0;
					line-height: 1px;
					color: #fff;
					font-weight: $font-weight-buttons;
					font-size: $font-size-button;
					font-family: "Roboto",Condensed,sans-serif;
					text-transform: uppercase;
					height: 45px;
					width: 140px;
					cursor: pointer;
					transition: background-color .127s;

					&#limpar {
						background-color: transparent;
						border: 1px solid #FFF;

						&:hover {
							background-color: #FFF2;
						}
					}

					&:hover {
						background-color: #2E5BBD;
					}
				}
			}

			.params-container-row {
				background-color: yellow;
				height: 45px;
			}
		}

		#params-container {

			#grid-header{
				position: relative;
				grid-area: header;
				top: 5px;
				font-family: $font-family;
				font-size: $font-size;
				font-weight: $font-weight-labels;
				color: #FFF;
			}

			.search-section{
				grid-area: textTitulo;
				background-color: #ffffff;
				height: 45px;
				margin-left: 0px;
				margin-top: 0px;
				padding: 16px 16px 16px 10px;

				#search{
					margin-left: 0px;
				}

				label {
					color: #808080;
					i {
						font-weight: 600;
						position: relative;
						top: 1px;
						left: 8px;
					}
				}

			}

			#codigo {
				grid-area: codigo;

				input {
					width: 100%;
					height: 45px;
					padding: 16px;
					border: none;
					border-radius: $border-radius;
					background-color: #FFF;
				}
			}

			#selectData {
				grid-area: selectData;
			}

			#selectStatus {
				grid-area: selectStatus;
			}

			#dataInicio, #dataFim {
				background-color: #ffffff;
				height: 45px;
				border-radius: 5px;
				padding: 0px 5px;
				display: flex;

				&.calendario-container {
					.box-date {
						width: 100%;
						i {
							position: relative;
							top: -35px;
							left: 6px;
							color: gray;
							font-size: 25px;
						}
					}
				}
			}

			#dataInicio {
				grid-area: dataInicio;
			}

			#dataFim {
				grid-area: dataFim;
			}

			.v-select {
				background-color: white;
				border-radius: 4px;
				border:none;
			}

			.vs__fade-enter-active,
			.vs__fade-leave-active {
				transition: none;
			}

			.v-select.area_3{
				height: 45px;
			}

			#objeto{
				grid-area: tipoObjeto;
				width: 100%;
			}

			#curador{
				grid-area: curador;
				width: 100%;
			}

			#curadoria{
				grid-area: curadoria;
				width: 100%;
			}

			#subcuradoria{
				grid-area: subcuradoria;
			}

			#eixo{
				grid-area: eixo;
				height: 45px;
			}

			.acoes {
				grid-area: acoes;
				justify-self: end;
				display: grid;
				grid-template-columns: 1fr 1fr;
				gap: 5px;

				@media only screen and (max-width: 640px) {
					margin-top: 0.5rem !important;
				}

				.btn {
					background-color: $success-color;
					border: none;
					border-radius: 4px;
					outline: none;
					padding: 20px 0;
					line-height: 1px;
					color: #fff;
					font-weight: $font-weight-buttons;
					font-size: $font-size-button;
					font-family: "Roboto",Condensed,sans-serif;
					text-transform: uppercase;
					height: 45px;
					width: 140px;
					cursor: pointer;
					transition: background-color .127s;

					&#limpar {
						background-color: transparent;
						border: 1px solid #FFF;

						&:hover {
							background-color: #FFF2;
						}
					}

					&:hover {
						background-color: #2E5BBD;
					}
				}
			}

			.params-container-row {
				background-color: yellow;
				height: 45px;
			}
		}

		.table-wrapper {
			.table {
				display:flex;
				padding: 5px 0px 0px;
				margin-top: 0px;
				padding-top: 0px;
				color: $main-color;
				font-weight: $font-weight-default-bolder;

				thead{
					th{
						&.ordena {
							i {
								margin-left: 5px;
								font-size: 12px;
								font-weight: 600;
							}
						}
					}
				}

				.fields {
					height: 45px;
					background-color: $inputs-color;
					text-align: left;

					td {
						vertical-align: middle;
						font-size: 0.9em;
						flex-grow: 0;
						color: gray;
						font-weight: 500;

						.code-error {
							font-size: .9em;
							font-weight: bold;

							&::before {
								content: '!';
								display: inline-flex;
								justify-content: center;
								align-items: center;
								width: 26px;
								height: 26px;
								margin-right: 10px;
								border-radius: 50%;
								background-color: #FFBB00;
								color: #FFF;
							}
						}
					}
					.objeto-nome {
						width: 30%;
					}
					.objeto-codigo {
						display: flex;
						.id-obj{
							text-overflow: ellipsis;
							overflow: hidden;
							white-space: nowrap;
						}
						.copy-id-obj{
							position: relative;
							top: 2px;
						}
					}
					.objeto-tipo {
						text-align: center;
						&.text-overflow {
							min-width: 75px;
							max-width: 162px;
							text-align: center;
							text-overflow: ellipsis;
							white-space: nowrap;
							overflow: hidden;
						}
						span {
							background-color: #fff;
							padding: 5px 20px;
							border-radius: 4px;
						}
					}
					.objeto-update {
						text-align: center;
					}
				}
			}
		}

		.objectNotFound {
			margin-top: 50px;
			color: #000;
			text-align: center;
		}
	}
	</style>

	<style lang="scss">
		.vdp-datepicker {
			border:none !important;
			height: 100%;
			width: 100%;
			color: gray;
			div:first-of-type {
				height: 100%;
				input[type=text] {
					width: 100%;
					height: 100%;
					text-align: left;
					border: none;
					font-family: $font-family;
					font-weight: $font-weight-input-bolder;
					font-size: $font-size;
					color: $font-color;
					padding-left: 35px;
					&:focus{
						outline-color: transparent;
					}
				}
			}
			.vdp-datepicker__clear-button {
				position: absolute;
				right: 10px;
				top: 5px;
				i {
					font-size: 30px;
				}
			}
		}
		.vs--searchable .vs__dropdown-toggle {
			height: 100%;
		}
	</style>
    <style>
		.acoes {
			margin-top: 1.7rem !important;
		}
		.tableFilho{
			position: absolute;
			right: 10px;
			width: 90%;
		}
		.tableFilho::before{
			content: '';
			height: 100%;
			left: -28px;
			top: -26px;
			border-left: 4px solid #2853ae;
			position: absolute;
			z-index: -5;
		}

		.filho::before{
			content: '';
			height: 55px;
			position: absolute;
			background-repeat: no-repeat;
			width: 42px;
			margin-top: 3px;
			left: -34px;
		}

        [v-cloak] {
            display: none;
        }
		.modal {
			width: 100% !important;
			font-size: 0.8rem !important;
			height: 100% !important;
			overflow-y: scroll;
			padding: 10px 32px;
			position: relative;
		}
		.close{
			position: absolute;
			top: 1px;
			right: -15px;
			font-size: 1.6rem;
			cursor:pointer;
		}
		.modal-footer{
			display: none !important;
		}
		td {
			border-start-start-radius: 0px !important;
			border-end-start-radius: 0px !important;
			border-start-start-radius: 0px !important;
			border-end-start-radius: 0px !important;
		}
		.actionPai {
			height: 100% !important;
			width: 105px !important;
		}
		.paiModalTitle{
			color:#1b3772;
			text-transform: uppercase;
			padding-top: 38px;
			font-weight:500;
			font-size:1.2rem;
			text-align: left !important;
			margin-bottom: 5px;
		}
		@media only screen and (max-width: 640px) {
			.container .content .main-content nav {
				justify-content:start !important;
			}
			.table-responsive {
				overflow: scroll;
				z-index: 3;
				display: block;
				width: auto;
				height: auto;
				position: relative;
				min-height: 500px;
			}
		}

    </style>
